import clsx from "clsx";

export default function Tabs({ tabs, selectedTab, setSelectedTab, onChange }) {
  return (
    <div className="mb-2 col-span-full">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          value={selectedTab}
          onChange={(e) => {
            setSelectedTab(e.target.value);
            // onChange(e.target.value);
          }}
          className="block cursor-pointer w-full rounded-t border-gray-300 focus:border-purple-500 focus:ring-purple-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block bg-gray-200 rounded-md">
        <nav aria-label="Tabs" className="flex space-x-4">
          {tabs.map((tab) => (
            <button
              onClick={() => {
                setSelectedTab(tab);
                // onChange(tab.name);
              }}
              key={tab.name}
              aria-current={selectedTab === tab.name ? "page" : undefined}
              className={clsx(
                tab.name === selectedTab.name
                  ? "bg-white text-gray-700"
                  : "text-gray-500 hover:text-gray-700",
                "rounded-md m-1 px-2 py-1.5 text-sm font-medium"
              )}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
